export const BADGES_CONFIG = {
  levels: [
    {
      id: 'crafter',
      minLikes: 10,
      title: 'levels.crafter_title',
      icon: 'Sparkles',
      color: 'text-blue-500',
      description: 'levels.crafter_description',
      longDescription: 'levels.crafter_long_description',
      tooltip: 'levels.crafter_tooltip',
    },
    {
      id: 'explorer',
      minLikes: 50,
      title: 'levels.explorer_title',
      icon: 'Compass',
      color: 'text-emerald-500',
      description: 'levels.explorer_description',
      longDescription: 'levels.explorer_long_description',
      tooltip: 'levels.explorer_tooltip',
    },
    {
      id: 'innovator',
      minLikes: 100,
      title: 'levels.innovator_title',
      icon: 'Lightbulb',
      color: 'text-amber-500',
      description: 'levels.innovator_description',
      longDescription: 'levels.innovator_long_description',
      tooltip: 'levels.innovator_tooltip',
    },
    {
      id: 'master',
      minLikes: 250,
      title: 'levels.master_title',
      icon: 'Crown',
      color: 'text-purple-500',
      description: 'levels.master_description',
      longDescription: 'levels.master_long_description',
      tooltip: 'levels.master_tooltip',
    },
  ],
}
